import AppModal, { AppModalFooter } from "@/components/AppModal";
import { Button } from "@/components/ui/button";
import {
  type ConfirmActionOptions,
  getConfirmActionSnapshot,
  settleConfirmAction,
  subscribeToConfirmAction,
} from "@/components/confirm-action";
import { useSyncExternalStore } from "react";

export type { ConfirmActionOptions } from "@/components/confirm-action";

function ConfirmActionContent({
  request,
  onSettle,
}: {
  request: ConfirmActionOptions;
  onSettle: (confirmed: boolean) => void;
}) {
  return (
    <>
      <div className="space-y-1" dir="rtl" data-testid="confirm-action-dialog">
        <h2 className="text-lg font-bold text-gray-950">{request.title}</h2>
        {request.description ? <p className="text-sm text-gray-600">{request.description}</p> : null}
      </div>

      <AppModalFooter>
        <div className="flex gap-2">
          <Button
            variant={request.destructive ? "destructive" : "default"}
            onClick={() => onSettle(true)}
            className="flex-1"
            data-testid="confirm-action-confirm"
          >
            {request.confirmLabel}
          </Button>
          <Button variant="outline" onClick={() => onSettle(false)} data-testid="confirm-action-cancel">
            {request.cancelLabel ?? "إلغاء"}
          </Button>
        </div>
      </AppModalFooter>
    </>
  );
}

/** Mounted once at the app root; renders the confirmation requested through `confirmAction`. */
export function ConfirmActionHost() {
  const { request, open } = useSyncExternalStore(
    subscribeToConfirmAction,
    getConfirmActionSnapshot,
    getConfirmActionSnapshot,
  );

  return (
    <AppModal open={open} onOpenChange={(value) => !value && settleConfirmAction(false)}>
      {request ? <ConfirmActionContent key={request.id} request={request} onSettle={settleConfirmAction} /> : null}
    </AppModal>
  );
}
